import { render, staticRenderFns } from "./TrainingResource.vue?vue&type=template&id=1fd6a74e&scoped=true"
import script from "./TrainingResource.vue?vue&type=script&lang=js"
export * from "./TrainingResource.vue?vue&type=script&lang=js"
import style0 from "./TrainingResource.vue?vue&type=style&index=0&id=1fd6a74e&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6a74e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd6a74e')) {
      api.createRecord('1fd6a74e', component.options)
    } else {
      api.reload('1fd6a74e', component.options)
    }
    module.hot.accept("./TrainingResource.vue?vue&type=template&id=1fd6a74e&scoped=true", function () {
      api.rerender('1fd6a74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/components/TrainingResource.vue"
export default component.exports